import { Component, OnInit, Input } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ActivatedRoute } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-dashboard-screenshots',
  templateUrl: './dashboard-screenshots.component.html',
  styleUrls: ['./dashboard-screenshots.component.scss']
})
export class DashboardScreenshotsComponent implements OnInit {

  projectId: any;
  projectName: any;
  projectMembers = [];
  selectedScreenShotDate: Date;
  imageDetails: any[];
  images = [];
  screenShotImage = [];
  @Input() selectedProjectId: any;
  @Input() selectedDate: any;
   

  ngOnChanges(selectedDate) {
    if (selectedDate.hasOwnProperty('selectedDate')) {
      this.getSelectedDate(selectedDate.selectedDate.currentValue);
    } else {
      this.getSelectedDate(new Date(selectedDate));
    }

  }

  constructor(
    private route: ActivatedRoute,
    private parseService: ParseService,
    private _lightbox: Lightbox,
    private storageConfiguration: StorageConfiguration

  ) {
     

  }

  ngOnInit() {

    this.route.params.subscribe(async params => {
      this.projectId = params.id;
      await this.getProMembers();
    });
  }

  getSelectedDate(selectedDate) {
    this.selectedScreenShotDate = selectedDate;
    if (this.projectMembers.length > 0) {
      this.last15DaysScreenShots(this.projectMembers[0].profileId);
    }
  }

  async getProMembers() {
    this.projectMembers = [];
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.include('user.profile');
    query.equalTo('status', 'Assigned');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.selectedProjectId });
    query.limit(500000);
    await query.find().then(results => {
      results.forEach(element => {
        this.projectMembers.push({
          profileId: element.get('user').get('profile').id,
          userName: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        });
      });
      this.last15DaysScreenShots(this.projectMembers[0].profileId);
    });
  }

  last15DaysScreenShots(profileId) {
    this.imageDetails = [];
    let img = '';
    this.images = [];
    let description = '';
    let queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
    let query = new this.parseService.instance.Query(queryInstance);
    let startend = this.startenddates(this.selectedDate);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.include('profileId');
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: profileId != '' ? profileId : this.projectMembers[0].profileId });
    query.find().then(results => {
      results.forEach(element => {
        this.imageDetails = element.get('imageDetails');
        this.imageDetails.forEach(innerElement => {
          description = 'Screenshots';
          img = innerElement.apiUrl;
          let recordedTime = (new Date(innerElement.recordedTime));
          this.images.push({
            src: img,
            caption: recordedTime,
            thumb: img
          });
        });
      });
      this.screenShotImage = this.images;
    });
  }


  open(index: number): void {
    // open lightbox
    this._lightbox.open(this.screenShotImage, index);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }


  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }




}